import GlassCard from '../ui/glass/components/GlassCard';

import React, { useState, useEffect } from 'react';
import {
  Box, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PageHeader from '../components/common/PageHeader';
import EmptyState from '../components/common/EmptyState';
import { Loading } from '../components/common/Loading';

// Firebase importları
import { db, functions } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

// Modal bileşenimiz
import UserFormModal from '../components/modals/UserFormModal';

const KullaniciYonetimi = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchUsers = async () => {
    try {
      const usersCollectionRef = collection(db, 'users');
      const querySnapshot = await getDocs(usersCollectionRef);
      const usersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(usersList);
    } catch (error) {
      console.error("Kullanıcıları çekerken hata oluştu: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchUsers();
  }, []);

  const handleAddNewUser = () => {
    setSelectedUser(null);
    setIsModalOpen(true);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleDeleteUser = async (userId, username) => {
    if (!window.confirm(`${username} adlı kullanıcıyı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.`)) {
      return;
    }

    setLoading(true);
    const deleteUser = httpsCallable(functions, 'deleteUser');
    try {
      await deleteUser({ userId });
      alert('Kullanıcı başarıyla silindi.');
      await fetchUsers();
    } catch (error) {
      console.error("Silme hatası:", error);
      alert(`Silme işlemi başarısız: ${error.message}`);
      setLoading(false);
    }
  };

  const handleSaveUser = async (userData) => {
    try {
      if (userData.userId) {
        const updateUser = httpsCallable(functions, 'updateUser');
        const result = await updateUser(userData);
        console.log(result.data.message);
        alert('Kullanıcı başarıyla güncellendi!');
      } else {
        const createNewUser = httpsCallable(functions, 'createNewUser');
        const result = await createNewUser(userData);
        console.log(result.data.result);
        alert('Yeni kullanıcı başarıyla oluşturuldu!');
      }
      await fetchUsers();
    } catch (error) {
      throw error;
    }
  };

  return (
    <Box sx={{ p: { xs: 1, md: 1 }, maxWidth: 'lg', m: 'auto' }}>
      <PageHeader
        title="Kullanıcı Yönetimi"
        subtitle="Sistem kullanıcıları ve yetkilendirmeler."
        icon={<ManageAccountsIcon />}
      >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddNewUser}
          >
            Yeni Kullanıcı Ekle
          </Button>
      </PageHeader>

      <GlassCard sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Kullanıcı Adı</TableCell>
                <TableCell>E-posta</TableCell>
                <TableCell>Rol</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ border: 0 }}>
                    <Loading message="Kullanıcılar yükleniyor..." />
                  </TableCell>
                </TableRow>
              ) : users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ border: 0 }}>
                    <EmptyState icon={<ManageAccountsIcon />} message="Henüz kullanıcı bulunmamaktadır." />
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={user.id}>
                    <TableCell>{user.username || '-'}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.role}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Düzenle">
                        <IconButton aria-label="Kullanıcıyı düzenle" size="small" color="primary" onClick={() => handleEditUser(user)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Sil">
                        <IconButton aria-label="Kullanıcıyı sil" size="small" color="error" onClick={() => handleDeleteUser(user.id, user.username)}>
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </GlassCard>

      <UserFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveUser}
        user={selectedUser}
      />
    </Box>
  );
};

export default KullaniciYonetimi;